import { filterClasses } from "@swivl-mono/helpers";
import { ReactNode } from "react";

interface ErrorProps {
  children: ReactNode;
  className?: string;
}

export function ErrorText({ children, className }: ErrorProps) {
  if (!children) return null;

  return <p className={filterClasses("body-sm mt-0.5 leading-none text-red-500", className)}>{children}</p>;
}
